import React from "react";
// import { Canvas } from "@react-three/fiber";
// import * as THREE from "three";

const Sphere = () => {
  return (
    <div className="skills-charts">
      <div id="myCanvasContainer">
        <canvas width="500" height="500" id="myCanvas">
          <div id="tags">
            <ul>
              <li>
                {" "}
                <a
                  data-weight="25"
                  href="https://en.wikipedia.org/wiki/HTML"
                  target="_blank"
                  rel="noreferrer"
                >
                  HTML
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://en.wikipedia.org/wiki/Cascading_Style_Sheets"
                  target="_blank"
                  rel="noreferrer"
                >
                  CSS
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://en.wikipedia.org/wiki/JavaScript"
                  target="_blank"
                  rel="noreferrer"
                >
                  ES5/ES6
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://en.wikipedia.org/wiki/JavaScript"
                  target="_blank"
                  rel="noreferrer"
                >
                  TypeScript
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://tailwindcss.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  TailwindCss
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://nodejs.org/en/"
                  target="_blank"
                  rel="noreferrer"
                >
                  NodeJS
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://reactjs.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  React
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://git-scm.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Git
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://graphql.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  GraphQL
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://developer.android.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Android
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://typeorm.io/"
                  target="_blank"
                  rel="noreferrer"
                >
                  TypeORM
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://reactnative.dev/"
                  target="_blank"
                  rel="noreferrer"
                >
                  React Native
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://www.mongodb.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  MongoDB
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://developer.apple.com/tutorials/swiftui"
                  target="_blank"
                  rel="noreferrer"
                >
                  SwiftUI
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://kotlinlang.org/docs/android-overview.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Kotlin
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://www.framer.com/motion/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Framer Motion
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://expressjs.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Express
                </a>
              </li>
              <li>
                <a
                  data-weight="25"
                  href="https://copilot.github.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Github Copilot
                </a>
              </li>
            </ul>
          </div>
        </canvas>
      </div>
      <div className="clear"></div>
    </div>
  );
};

export default Sphere;
